<a [href]="link | safe" target="_blank">
  <mat-icon fontIcon="mdi-help-circle" color="primary"></mat-icon>
</a>
